An array of `JobCategory` identifiers.

Scheme requirements:

- The `seekAnz` scheme requires exactly one element.
